export const parseWidgetProps = <T extends {}>(el: Element): T => {
  const widgetProps = el.getAttribute('data-widget-props');
  if (!widgetProps) {
    throw Error('Missing widget props attribute');
  }
  return JSON.parse(widgetProps);
};
